<div
  [ngClass]="{ 'rounded-bl rounded-br': !professioneel }"
  class="flex p-4 justify-between items-center rounded-tl rounded-tr bg-n-200 hover:bg-n-300 transition-colors"
>
  <div [ngClass]="classes" class="flex items-start gap-x-3">
    <parkour-avatar-badge
      [image]="image"
      [ngClass]="{ 'opacity-50': disabled }"
      classes="w-[3rem] h-[3rem] rounded overflow-hidden"
    />

    <div class="flex flex-col items-start gap-y-1 whitespace-normal">
      <p class="typo-body variant-body-fat">{{ naam }}</p>
      <span class="typo-body text-n-600 flex align-center gap-x-1">
        {{ rol | rolLabel }}
        @if (professioneel) {
          <parkour-icon class="inline-flex" name="badge-on" type="inline" />
        }
      </span>

      <ng-content></ng-content>
    </div>
  </div>
  <parkour-icon class="text-n-600" name="chevron-right" size="3" />
</div>
@if (professioneel && status === 'AANVAARD') {
  <div>
    <div class="flex gap-4 p-4 rounded-br rounded-bl bg-n-300">
      <div class="rounded bg-n-400 p-3 w-[3rem] h-[3rem]">
        <parkour-icon class="text-n-1000 w-full" name="check" size="3" />
      </div>
      <p class="block">{{ 'team.uitnodiging-professioneel-description' | translate: { naam } }}</p>
    </div>
  </div>
}
